import { Box, Typography, Container } from "@mui/material";
import ISO1 from "../../assets/iso1.jpeg";
import ISO2 from "../../assets/iso1.jpeg";
import ISO3 from "../../assets/iso1.jpeg";
const brandBlue = "#1a237e";
const brandRed = "#d50000";



const certifications = [
  ISO1, ISO2, ISO3];


export default function ISOcertifications() {
  return (
    <Box
      sx={{
        py: { xs: 8, md: 10 },
        backgroundColor: "#f5f7fc",
      }}
    >
      <Container maxWidth="lg">
        {/* Heading */}
        <Typography
          variant="h4"
          fontWeight={800}
          sx={{
            textAlign: "center",
            mb: 1,
            color: brandBlue,
            fontSize: { xs: "1.9rem", md: "2.3rem" },
          }}
        >
          ISO Certifications
        </Typography>

        {/* Underline */}
        <Box
          sx={{
            width: 90,
            height: 4,
            backgroundColor: brandRed,
            borderRadius: 2,
            mx: "auto",
            mb: 6,
          }}
        />

        {/* Certifications Grid */}
        <Box
          sx={{
            display: "flex",
            gap: 4,
            flexWrap: "wrap",
            justifyContent: "center",
          }}
        >
          {certifications.map((item, index) => (
            <Box
              key={index}
              sx={{
                flex: "1 1 430px",
                maxWidth: "420px",
                backdropFilter: "blur(10px)",
                background: "rgba(255,255,255,0.5)",
                borderRadius: "22px",
                padding: 1,
                boxShadow:
                  "0 10px 35px rgba(0,0,0,0.1), inset 0 0 20px rgba(255,255,255,0.2)",
                border: "1px solid rgba(255,255,255,0.8)",
                transition: "0.35s all ease",
                "&:hover": {
                  transform: "translateY(-8px)",
                  boxShadow: `0 18px 45px ${brandBlue}33`,
                },
              }}
            >
              <Box
                component="img"
                src={certifications[index]}
                alt="ISO Certification"
                sx={{
                  width: "100%",
                  height: 240,
                  objectFit: "contain",
                  borderRadius: "16px",
                  boxShadow: "0 8px 25px rgba(0,0,0,0.12)",
                }}
              />
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
}
